import React__default from 'react';
import './ToggleCardHeader.scss';

const ToggleCardHeader = ({ title, accessory, }) => {
    return (React__default.createElement("div", { className: 'toggle-card-header--rev' },
        React__default.createElement("div", { className: 'radio-button--rev' }),
        title && React__default.createElement("div", { className: 'header-title--rev h2' }, title),
        accessory));
};

export { ToggleCardHeader };
//# sourceMappingURL=ToggleCardHeader.js.map
